import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SupplierListFilters from '../components/SupplierListFilters';
import TopBar from '../../../components/TopBar';
import {
  fetchSuppliersRequest,
  markSupplierCreated,
  markSupplierEdited,
  resetSelectedSupplier,
} from '../../../api/suppliers/suppliersSlice';
import SupplierListPageActions from '../components/SupplierListPageActions';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SuppliersTable from '../components/SuppliersTable';
import { Stack } from '@mui/material';

const filters = [
  {
    type: 'search',
    options: [
      {
        key: 'name',
        placeholder: 'Name',
      },
      {
        key: 'email',
        placeholder: 'Email',
      },
    ],
  },
];

const columns = [
  {
    columnName: 'Name / Company Name',
    mappingField: 'name',
  },
  {
    columnName: 'Contact Info',
    mappingField: 'email',
  },
  {
    columnName: 'Registration Number',
    mappingField: 'registration_number',
  },
  {
    columnName: 'Country',
    mappingField: 'country_code',
  },
  {
    columnName: 'Actions',
    mappingField: 'actions',
  },
];

function SupplierListPage() {
  useDocumentTitle('Supplier List');
  const dispatch = useDispatch();
  const user = useSelector((state) => state.org.org.user);
  const { error } = useSelector((state) => state.suppliers);
  const [selectedFilter, setSelectedFilter] = useState(filters.length > 0 ? filters[0].options[0].key : '');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentQuery, setCurrentQuery] = useState({});

  useEffect(() => {
    dispatch(markSupplierCreated(false));
    dispatch(markSupplierEdited(false));
    dispatch(resetSelectedSupplier());
    dispatch(fetchSuppliersRequest({ url: '/suppliers', page: 1, limit: 10 }));
  }, [dispatch]);

  if (error) return <div>Error: {error}</div>;

  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
    const searchBy = event.target.value;
    const query = {
      page: 1,
      limit: 10,
    };
    if (searchTerm) {
      query[searchBy] = searchTerm;
    }

    dispatch(
      fetchSuppliersRequest({
        query: query,
      }),
    );
  };

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handleSearchKeyPress = (event) => {
    const query = {
      page: 1,
      limit: 10,
    };
    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }
    if (event.key === 'Enter') {
      setCurrentQuery(query);
      dispatch(
        fetchSuppliersRequest({
          query: query,
        }),
      );
    }
  };

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Suppliers">{user?.permissions?.suppliers === 2 && <SupplierListPageActions />}</TopBar>
      <SupplierListFilters
        filters={filters}
        selectedFilter={selectedFilter}
        onFilterChange={handleFilterChange}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onSearchKeyPress={handleSearchKeyPress}
      />
      <SuppliersTable searchQuery={currentQuery} />
    </Stack>
  );
}

export default SupplierListPage;
